import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const ComponentsContext = createContext({
    components: new Map(),
});
export function ComponentsProvider({ components, children }) {
    const componentsMap = new Map();
    for (const comp of components) {
        componentsMap.set(comp.name, comp);
    }
    return (_jsx(ComponentsContext.Provider, { value: { components: componentsMap }, children: children }));
}
export function useComponents() {
    return useContext(ComponentsContext);
}
export function useComponentDef(name) {
    const { components } = useComponents();
    return components.get(name);
}
//# sourceMappingURL=ComponentsContext.js.map